import random from 'lodash/random'
import { ALCHEMY_RPC_URL } from './Enviroment'

export const nodes = [ALCHEMY_RPC_URL]

const getNodeUrl = () => {
    const randomIndex = random(0, nodes.length - 1)
    return nodes[randomIndex]
}

export default getNodeUrl

